<template>
  <div>
    <div style="padding:0px 16px 0px 0px" class="d-flex justify-end">
      <v-btn
        fab
        depressed
        style="margin-left:85%;text-align:end;margin-bottom:10px"
        small
        right
        color="white"
        @click="closeWithdraw()"
        ><v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-card
      style="
width: 400px;
height:475px;
border-radius: 12px;
"
      elevation="24"
      class="pa-8"
      :loading="loading"
    >
      <v-window v-model="step">
        <v-window-item :value="1">
          <p>Enter your 4-digit pin before you can proceed to withdraw</p>
          <v-row class="mt-15">
            <v-col>
              <v-text-field
                solo
                v-model="one"
                ref="one"
                @input="moveToTwo()"
                @keyup="checkPin()"
              />
            </v-col>
            <v-col>
              <v-text-field
                solo
                ref="two"
                v-model="two"
                @input="moveToThree()"
                @keyup="checkPin()"
              />
            </v-col>
            <v-col>
              <v-text-field
                solo
                ref="three"
                v-model="three"
                @input="moveToFour()"
                @keyup="checkPin()"
              />
            </v-col>
            <v-col>
              <v-text-field
                solo
                ref="four"
                v-model="four"
                @keyup="checkPin()"
              />
            </v-col>
          </v-row>
          <v-btn
            :disabled="disabled"
            style="margin-top:30px;border-radius:12px"
            class="white--text"
            large
            block
            color="red"
            @click="step++"
          >
            Proceed</v-btn
          >
        </v-window-item>
        <v-window-item :value="2">
          <div>
            <h2 style="font-size:16px">Withdraw funds</h2>
            <p style="font-size:10px">
              Your wallet balance is
              <span class="font-weight-bold"
                >{{userData.currency}} {{
                  parseFloat(walletBalance.toFixed(2)).toLocaleString("en")
                }}.</span
              >Transfer charge is {{userData.currency}} {{parseFloat(0.04*(amount))}}
            </p>
            <v-form ref="form">
              <v-text-field
                outlined
                v-model="amount"
                type="number"
                label="Amount"
                color="red"
                style="margin-top:16px;height:62px"
                @keyup="canWithdraw()"
              />
              <v-select
                outlined
                v-model="bank"
                :items="bankDetails"
                label="Select Bank"
                color="red"
                :item-text="'bankname'"
                :item-value="'bank'"
                style="margin-top:16px;height:62px"
                @change="canWithdraw()"
              />
              <v-text-field
                outlined
                v-model="note"
                label="Personalized note"
                color="red"
                style="margin-top:16px;height:62px"
                @keyup="canWithdraw()"
              />
              <p
                style="margin-top:11px;font-size:14px;color:#95A1A6;font-weight:400"
              >
                Can’t find your bank details?
                <router-link
                  to="/settings"
                  style="text-decoration:none;color:red"
                  >Transfer to a new account</router-link
                >
              </p>
              <div style="margin-top:32px">
                <v-btn
                  depressed
                  @click="closeWithdraw()"
                  height="48px"
                  width="35%"
                  style="font-size:14px;border-radius:8px"
                  >Cancel</v-btn
                >

                <v-btn
                  depressed
                  :style="{ opacity: opacity }"
                  @click="withdrawal()"
                  height="48px"
                  width="60%"
                  style="margin-left:1%;float:right;font-size:14px;border-radius:8px"
                  class="createAccount white--text"
                  >Withdraw funds</v-btn
                >
              </div>
            </v-form>
            <v-dialog v-model="success" max-width="500">
              <v-card elevation="24" class="createAccount pa-7 text-center">
                <v-icon size="100px" color="white">mdi-check-circle</v-icon>
                <h1
                  style="font-size:23px;padding:10px;color:white"
                  class="font-weight-black"
                >
                  {{ title }}
                </h1>
                <p style="font-size:15px;color:white">{{ message }}</p>
                <v-btn @click="successfullyWithdrawn()" elevation="24">
                  Ok</v-btn
                >
              </v-card>
            </v-dialog>

            <v-dialog v-model="error" max-width="500">
              <v-card elevation="24" class="createAccount pa-7 text-center">
                <v-icon size="100px" color="white">mdi-close-circle</v-icon>
                <h1
                  style="font-size:23px;padding:10px;color:white"
                  class="font-weight-black"
                >
                  {{ title }}
                </h1>
                <p style="font-size:15px;color:white">
                  {{ message }}
                </p>
                <v-btn @click="error = false" elevation="24"> Close</v-btn>
              </v-card>
            </v-dialog>
          </div>
        </v-window-item>
      </v-window>
       <v-overlay
              :absolute="absolute"
              opacity="0.7"
              :value="withdrawLoading"
            >
              <v-progress-circular
                :size="70"
                :width="7"
                color="red"
                indeterminate
              ></v-progress-circular>
              <p class="text-center">Processing...</p>
            </v-overlay>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import db from "../db";
import { doc, updateDoc, arrayUnion,increment } from "firebase/firestore";

export default {
  name: "Withdraw",

  data() {
    return {
      note: "",
      amount: "",
      bank: "",
      opacity: 0.4,
      withdrawLoading: false,
      absolute: true,
      success: false,
      error: false,
      title: "",
      message: "",
      step: 1,
      disabled: true,
      one: "",
      two: "",
      three: "",
      four: "",
      pinCode: [
        { id: 1, datatype: "one" },
        { id: 2, datatype: "two" },
        { id: 3, datatype: "three" },
        { id: 4, datatype: "four" }
      ],
      Pin: ""
    };
  },

  computed: {
    ...mapState({
      loading: "loading",
      userData: "userData",
      walletBalance: "walletBalance",
      activities: "activities",
      bankDetails: "bankDetails",
      subscribers: "subscribers",
      notifications: "notifications",
      username: "username",
      setPin: "setPin",
      securityPin: "securityPin"
    }),

    accountNumber() {
      return this.bankDetails.filter(bank => bank.bank == this.bank)[0]
        .accountNumber;
    }
  },

  created() {},

  methods: {
    closeWithdraw() {
      this.$emit("closeWithdraw");
      this.$refs.form.reset();
    },

    canWithdraw() {
      if (
        parseFloat(1.05*(this.amount)) < this.walletBalance &&
        this.amount != "" &&
        this.bank != ""
      ) {
        this.opacity = 1;
      } else {
        this.opacity = 0.4;
      }
    },

    withdrawal() {
      if (
         parseFloat(1.05*(this.amount)) < this.walletBalance &&
        this.amount != "" &&
        this.bank != ""
      ) {
        this.withdrawLoading = true;
        console.log({
          bank: this.bank,
          accountNumber: this.accountNumber,
          amount: this.amount
        });
        axios({
          method: "post",
          url: "https://tips-api.herokuapp.com/transfer",
          data: {
            bank: this.bank,
            accountNumber: this.accountNumber,
            amount: this.amount
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(response => {
            console.log(response);
            this.withdrawLoading = false;
            this.success = true;
            this.title = "Withdrawal Successful!";
            this.message = `${this.userData.currency} ${this.amount} is on its way to your bank account!`;
            this.notificationPayload = {
              title: "Withdrawal Successful!",
              message: `${this.userData.currency} ${parseInt(
                this.amount
              )} has been successfully withdrawn from your Tippings wallet.`,
              timestamp: moment(Date.now()).format("LLL")
            };

            this.transactionPayload = {
              title: "Withdrawal Successful!",
              status: "successful",
              amount: `${parseFloat(this.amount).toFixed(2)}`,
              timestamp: moment(Date.now()).format("LLL"),
              image: "https://i.ibb.co/vVLYxMN/withdraw.png",
              currency:this.userData.currency
            };
            const user = doc(db, "users", localStorage.getItem("tippingsKey"));
            updateDoc(user,{
              wallet: increment(-(parseFloat(1.04*(this.amount)))),
              notifications: arrayUnion(this.notificationPayload),
              transactions: arrayUnion(this.transactionPayload)
            });
          })
          .catch(error => {
            console.log(error);
            this.withdrawLoading = false;
            this.error = true;
            this.title = "Withdrawal Not Successful!";
            this.message =
              "Something prevented us from completing this withdrawal request. Please try again later";
          });
      } else {
        return
      }
    },

    successfullyWithdrawn() {
      location.reload();
    },

    checkPin() {
      this.Pin = this.one + this.two + this.three + this.four;
      if (parseInt(this.Pin) == this.securityPin) {
        this.disabled = false;
      }
      if (
        this.one == "" &&
        this.two == "" &&
        this.three == "" &&
        this.four == ""
      ) {
        this.disabled = true;
      }else if( this.one == "" ||
        this.two == "" ||
        this.three == "" ||
        this.four == ""){
          this.disabled = true
        }
    },

    moveToTwo() {
      this.$refs.two.focus();
    },
    moveToThree() {
      this.$refs.three.focus();
    },
    moveToFour() {
      this.$refs.four.focus();
    }

    // withdrawal() {
    //   this.withdrawLoading = true
    //   if (this.amount != "" && this.bank != "") {
    //     let token = localStorage.getItem("duffleToken");
    //     axios({
    //       method: "post",
    //       url: "https://duffle-client.herokuapp.com/api/v1/bank/withdraw",
    //       data:{
    //       bank_id:this.bank,
    //       amount:this.amount,
    //       note:this.note
    //       },
    //       headers: {
    //         ContentType: "application/json",
    //         Authorization: "Bearer " + `${token}`,
    //       },
    //     }).then(
    //       (response) => {
    //       if (response.data.errors != null) {
    //       this.error = true;
    //       this.title = "Withdrawal Unsuccessful";
    //       this.message = response.data.errors[0];
    //       this.withdrawLoading = false;
    //     } else {
    //       this.success = true;
    //       this.title = "Withdrawal Successful"
    //       this.message = response.data.message;
    //       this.withdrawLoading = false;

    //     }
    //       },
    //     );
    //   }
    // },
  }
};
</script>
